<script setup lang="ts">
const baseUrl = useRuntimeConfig().public.pntBaseUrl;
defineEmits(["register-event"]);
</script>

<template>
  <div class="relative">
    <SkeletonLazy
      image-src="/images/hero-mobile.png"
      overlay
      ratio="386 / 579"
      class="!min-h-[550px]"
    >
      <div
        class="absolute text-center top-12 sm:top-[15%] text-white px-5 z-30"
      >
        <h1 class="text-xl sm:text-[32px] sm:leading-9 font-extrabold">
          Scopri il nostro programma fedeltà Prénatal Lover
        </h1>

        <p class="mt-5 mb-6 text-sm leading-4 px-6">
          Prénatal premia la tua fedeltà con una nuova raccolta punti.
          Ti aspettano tanti vantaggi, sconti e servizi dedicati.
        </p>
        <div
          class="w-full flex flex-col justify-between gap-5 items-center text-center text-base"
        >
          <div class="w-56">
            <h1 class="font-bold mb-3">Non hai ancora una card?</h1>
            <nuxt-link
              :to="`${baseUrl}/registrazione-qr/?utm_source=prenatal&utm_medium=hpareaclienti&utm_campaign=prenatal-lover`"
              target="_blank"
              @click="$emit('register-event')"
            >
              <CorePrimaryButton class="!rounded-lg">
                <div>REGISTRATI ORA, È GRATIS</div>
              </CorePrimaryButton>
            </nuxt-link>
          </div>
          <div class="w-56">
            <h1 class="font-bold mb-3">
              Vuoi gestire il tuo profilo e i tuoi vantaggi?
            </h1>
            <nuxt-link to="/login" @click="$emit('register-event')">
              <CorePrimaryButton class="!rounded-lg">
                <div>ACCEDI ALLA TUA AREA PERSONALE</div>
              </CorePrimaryButton>
            </nuxt-link>
          </div>
        </div>
      </div>
    </SkeletonLazy>
  </div>
</template>
